import React from 'react';

const Message = React.memo(({ message, formatText }) => {
  const messageClass = `message ${message.type} ${message.isWelcome ? 'welcome' : ''}`;

  return (
    <div className={messageClass}>
      <div className="message-header">
        <span className="message-sender">
          {message.type === 'user' ? '👮 Agente' :
           message.type === 'assistant' ? '🤖 SentencIA' :
           '⚠️ Sistema'}
        </span>
        <span className="message-time">{message.timestamp}</span>
      </div>

      {message.isWelcome ? (
        <div className="welcome-content">
          <div
            className="message-content"
            dangerouslySetInnerHTML={{ __html: formatText(message.content, true) }}
          />
        </div>
      ) : (
        <div
          className="message-content"
          dangerouslySetInnerHTML={{ __html: formatText(message.content) }}
        />
      )}

      {message.sources && message.sources.length > 0 && (
        <div className="sources">
          <div className="sources-header">📚 Fuentes consultadas:</div>
          <ul className="sources-list">
            {message.sources.map((source, idx) => (
              <li key={idx} className="source-item">
                <a
                  href={source.split(' ').pop()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="source-link"
                >
                  {source}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
});

export default Message;
